<template>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <a href="#" class="text-secondary text-decoration-none">
        <i class="fas fa-search"></i> Szukaj
      </a>
      <a href="#" class="text-primary text-decoration-none">
        <i class="fas fa-sync"></i> Odśwież
      </a>
    </div>
    <hr>
    <h2 class="text-center">Edytuj miejsce</h2>
    <form @submit.prevent="putPlace()">
      <div class="mb-3">
        <label for="place-name" class="form-label">Nazwa</label>
        <input type="text" class="form-control" id="place-name" v-model="place.name">
      </div>
      <div class="mb-3">
        <label for="place-short-name" class="form-label">Nazwa skrócona</label>
        <input type="text" class="form-control" id="place-short-name" v-model="place.acronym">
      </div>
      <div class="mb-3">
        <label for="place-address" class="form-label">Adres</label>
        <input type="text" class="form-control" id="place-address" v-model="place.address" @input="updatePositions();makeCoordsWithInput()">
      </div>
      <div class="mb-3">
        <label for="place-suggestion" class="form-label">Podpowiedzi</label>
        <select id="place-suggestion" class="form-control" @change="setBounds($event);makeCoordsWithInput()" @input="setBounds($event);makeCoordsWithInput()" @option:select="setBounds($event);makeCoordsWithInput()">
          <option
            v-for="(suggestion, key) in this.suggestions.results"
            :key="key"
            :value="`${suggestion.geometry.location.lat}_${suggestion.geometry.location.lng}`"
          >
            {{ suggestion.formatted_address }}
          </option>
        </select>
      </div>
      <div class="mb-3">
        <label for="place-positions" class="form-label">Współrzędne</label>
        <input id="place-positions" type="text" class="form-control" v-model="positions">
      </div>
      <div class="mb-3">
        <label for="place-description" class="form-label">Opis miejsca</label>
        <textarea name="description" class="form-control" id="place-description" rows="10" v-model="place.description"></textarea>
      </div>
      <button type="submit" class="btn btn-primary">Zatwierdź</button>
    </form>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'EditPlace',
  components: { Navbar },
  data () {
    return {
      place: {},
      suggestions: [],
      positionLatitude: 0,
      positionLongitude: 0,
      positions: '',
      currentSuggestion: null
    }
  },
  mounted () {
    this.fetchPlace()
  },
  methods: {
    async fetchPlace () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      try {
        this.place = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Place/${this.$route.params.id}`, config)).data
        this.updatePositions()
        this.positions = `${this.place.positionLatitude},${this.place.positionLongitude}`
        this.positionLatitude = this.place.positionLatitude
        this.positionLongitude = this.place.positionLongitude
      } catch (e) {
        console.log(e)
      }
    },
    async putPlace () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const putData = {
        name: this.place.name.trim(),
        acronym: this.place.acronym.trim(),
        address: this.place.address.trim(),
        positionLatitude: this.positions.split(',')[0],
        positionLongitude: this.positions.split(',')[1],
        description: this.place.description
      }

      try {
        await axios.put(`${process.env.VUE_APP_API_BASE_URL}Place/${this.$route.params.id}`, putData, config)
        await Swal.fire('Zaktualizowano miejsce', '', 'success')
        await this.$router.push({
          name:'PlacesList'
        })
      } catch (e) {
        console.log(e)
        await Swal.fire('Nie udało się zaktualizować miejsca', '', 'error')
      }
    },

    makeCoordsWithInput () {
      if (this.suggestions.results[0]) {
        this.positions = `${this.suggestions.results[0].geometry.location.lat},${this.suggestions.results[0].geometry.location.lng}`
      }
    },

    updatePositions () {
      const urlEncodedAddress = encodeURI(this.place.address)
      const apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + urlEncodedAddress + '&key=AIzaSyDYAQTlVi1D2Yrr2KsWv6Ql4kCPeUhDyic'

      axios.get(apiUrl).then(response => {
        this.suggestions = response.data
      }).catch(error => {
        console.log(error)
      })
    },
    setBounds (event) {
      this.positionLatitude = event.target.value.split('_')[0]
      this.positionLongitude = event.target.value.split('_')[1]
      this.positions = `${this.positionLatitude},${this.positionLongitude}`
    }
  }
}
</script>
